export default "__VITE_ASSET__BNpqJgiG__"